import BalanceTopUp from "components/BalanceTopUp";
import { TopUpBalanceContextProvider } from "context/TopUpBalanceContext";

const TopUpBalancePage = () => {
  return (
    <TopUpBalanceContextProvider>
      <BalanceTopUp />
    </TopUpBalanceContextProvider>
  );
};

export default TopUpBalancePage;
